import { createAction } from '@reduxjs/toolkit'
import {
  DrawingFile,
  AnalyzeResult,
  LoadingPage,
  DrawingType,
  FileType,
  ConvertFailedErrorType,
} from '../models/File'
import { ConvertFailedResponse } from '../models/Construction'

export const addDrawingFile = createAction<{ file: DrawingFile }>(
  'files/addDrawingFile',
)
export const updateDrawingFile = createAction<{
  fileId: string
  newFile: DrawingFile
}>('files/updateDrawingFile')
export const removeDrawingFile = createAction<{ fileId: string }>(
  'files/removeDrawingFile',
)
export const updatePage = createAction<{ fileId: string; page: LoadingPage }>(
  'files/updatePage',
)
export const addFileDescription = createAction<{
  fileId: string
  description: AnalyzeResult
}>('files/addFileDescription')
export const sortPages = createAction('files/sortPages')
export const switchPageCheckbox = createAction<{ pageId: string }>(
  'files/switchPageCheckbox',
)
export const selectPage = createAction<{ pageId: string }>('files/selectPage')
export const replacePage = createAction<{ pageId: string; newPageId: string }>(
  'files/replacePage',
)
export const addPage = createAction<{ pageId: string; type: DrawingType }>(
  'files/addPage',
)
export const removePage = createAction<{ pageId: string }>('files/removePage')
export const selectFile = createAction<{ fileName: string }>('files/selectFile')
export const setIsLoading = createAction<boolean>('files/setIsLoading')
export const updateS3FolderName = createAction<string>(
  'files/updateS3FolderName',
)
export const setFilesType = createAction<FileType | null>('files/setFilesType')
export const setConvertIssues = createAction<ConvertFailedResponse>(
  'files/setConvertIssues',
)
export const setConvertFixes = createAction<{ [key: number]: string }>(
  'files/setConvertFixes',
)
export const setConvertFailedError = createAction<
  ConvertFailedErrorType | undefined
>('files/setConvertFailedError')
export const clearState = createAction('files/clearState')
export const clearAnalyzeResults = createAction('files/clearAnalyzeResults')
export const clearConvertResults = createAction('files/clearConvertResults')
